module.exports = __webpack_public_path__ + "img/logo.b3592d6f.webp";